export const DomainIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.33398 7.9987H14.6673M1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654M1.33398 7.9987C1.33398 4.3168 4.31875 1.33203 8.00065 1.33203M14.6673 7.9987C14.6673 11.6806 11.6825 14.6654 8.00065 14.6654M14.6673 7.9987C14.6673 4.3168 11.6825 1.33203 8.00065 1.33203M8.00065 1.33203C9.66818 3.1576 10.6159 5.52672 10.6673 7.9987C10.6159 10.4707 9.66818 12.8398 8.00065 14.6654M8.00065 1.33203C6.33313 3.1576 5.38548 5.52672 5.33398 7.9987C5.38548 10.4707 6.33313 12.8398 8.00065 14.6654'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
